import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'

export const mapPartnerIds = (partner: IWWPartners) => partner.PartnerID
